<template>
  <v-container fluid class="d-flex align-center justify-center fill-height">
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" sm="10" md="8">
        <v-card class="pa-5" elevation="3">
          <v-card-title class="text-center">Contact Us</v-card-title>
          <v-card-text>
            <v-form ref="form">
              <!-- Subject field - required -->
              <v-text-field
                v-model="subject"
                label="Subject"
                prepend-icon="mdi-text-box"
                :error-messages="subjectError"
                maxlength="200"
                clearable
              ></v-text-field>

              <!-- Message field - required -->
              <v-textarea
                v-model="message"
                label="Message"
                prepend-icon="mdi-message-text"
                :error-messages="messageError"
                maxlength="1200"
                clearable
                counter
                variant="outlined"
                rows="6"
              ></v-textarea>

              <v-btn
                color="primary"
                class="mt-4"
                block
                :loading="loading"
                @click="submitData"
              >
                Submit Feedback
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar for success message -->
    <v-snackbar
      v-model="snackbarSuccess"
      color="success"
      top
      multi-line
      :timeout="4000"
    >
      {{ successMessage }}
      <template v-slot:actions>
        <v-btn color="white" text @click="snackbarSuccess = false">Close</v-btn>
      </template>
    </v-snackbar>

    <!-- Snackbar for error message -->
    <v-snackbar
      v-model="snackbarError"
      color="error"
      top
      multi-line
      :timeout="5000"
    >
      {{ errorMessage }}
      <template v-slot:actions>
        <v-btn color="white" text @click="snackbarError = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      subject: '',
      message: '',
      subjectError: '',
      messageError: '',
      loading: false,
      snackbarSuccess: false,
      snackbarError: false,
      successMessage: '',
      errorMessage: '',
    };
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'username', 'email']),
    accessToken() {
      // Get access token from localStorage
      return localStorage.getItem('access_token');
    },
  },
  methods: {
    async submitData() {
      // Manual validation only on submit
      this.subjectError = '';
      this.messageError = '';

      let valid = true;
      if (!this.subject || !this.subject.trim()) {
        this.subjectError = 'This field is required.';
        valid = false;
      } else if (this.subject.length > 200) {
        this.subjectError = 'Maximum 200 characters allowed.';
        valid = false;
      }

      if (!this.message || !this.message.trim()) {
        this.messageError = 'This field is required.';
        valid = false;
      }

      if (!valid) {
        this.errorMessage = 'Please fill in all required fields correctly.';
        this.snackbarError = true;
        return;
      }

      this.loading = true;

      try {
        // Prepare request data using store values
        const requestData = {
          access_token: this.accessToken,
          name: this.username,
          email: this.email,
          subject: this.subject,
          message: this.message,
        };

        const config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: '/api/user/ContactUs/',
          headers: {
            'Content-Type': 'application/json',
          },
          data: JSON.stringify(requestData),
        };

        const response = await axios.request(config);

        console.log('Response:', response.data);

        // Show success message
        this.successMessage = 'Thank you for your feedback! We will review it as soon as possible.';
        this.snackbarSuccess = true;

        // Reset form
        this.resetForm();

        // Redirect to home page after 3 seconds
        setTimeout(() => {
          this.$router.push('/');
        }, 3000);

      } catch (error) {
        console.error('Error submitting feedback:', error);

        // Handle different error scenarios
        if (error.response) {
          // Server responded with error status
          if (error.response.status === 401) {
            this.errorMessage = 'Your session has expired. Please log in again.';
          } else if (error.response.status === 400) {
            this.errorMessage = 'Invalid request. Please check your input.';
          } else if (error.response.status === 500) {
            this.errorMessage = 'Server error. Please try again later.';
          } else {
            this.errorMessage = 'Failed to submit feedback. Please try again.';
          }
        } else if (error.request) {
          // Request was made but no response received
          this.errorMessage = 'Network error. Please check your connection and try again.';
        } else {
          // Something else happened
          this.errorMessage = 'An unexpected error occurred. Please try again.';
        }

        this.snackbarError = true;
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      // Clear form fields and error messages
      this.subject = '';
      this.message = '';
      this.subjectError = '';
      this.messageError = '';
    },
  },
};
</script>

<style scoped>
.fill-height {
  min-height: 100vh;
}
</style>
